import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core"
import { FormBuilder, FormGroup } from "@angular/forms"
import { LexTranslateService } from "@app/core/services/lex-translate.service"

import { ErrorHandlerService } from "src/app/cadastro/admin/services/error-handler.service"
import { FilterState } from "src/app/cadastro/admin/services/states/filter.state"
import { EmptyReferences } from "src/app/shared/enum/emptyReferences"

@Component({
  selector: "seb-table-filter-subject",
  templateUrl: "./table-filter-subject.component.html",
  styleUrls: ["./table-filter-subject.component.css"],
})
export class TableFilterSubjectComponent implements OnInit {
  @Output() evFilter: EventEmitter<any> = new EventEmitter<any>()
  @Input() filterSubject: string = ""

  filterSubjectForm: FormGroup
  errorHandler: (err: any) => void

  constructor(
    private fb: FormBuilder,
    private errorHandlerService: ErrorHandlerService,
    private filterState: FilterState,
    public lextranslate: LexTranslateService
  ) {
    this.errorHandler = this.errorHandlerService.handle(
      "status",
      "filter_groups_error",
      "status"
    )
  }

  ngOnInit() {
    this.filterSubjectForm = this.fb.group({
      Name: this.fb.control(null, []),
    })
    if (this.filterState.states.filterFields !== EmptyReferences.OBJECT) {
      this.updateForm(this.filterState.states.filterFields)
    }
  }
  updateForm(stateValue) {
    this.filterSubjectForm.patchValue({
      Name: stateValue.Name,
    })
  }

  onFiltering() {
    this.filterState.states.filterFields = this.filterSubjectForm.value
    this.evFilter.emit(this.filterSubjectForm.getRawValue())
  }

  clearFilter() {
    this.filterState.resetState()
    this.filterSubjectForm.reset()
    this.onFiltering()
  }

  get existFilters(): boolean {
    const formValues = this.filterSubjectForm.value
    return formValues.Name
  }
}
